import { Box, styled } from '@mui/material'
import React from 'react'
import Sidebar from '../components/project/navigations/Sidebar'
import Navbar from '../components/project/navigations/Navbar'
import { COLORS } from '../constants/colors'
import { SIDEBAR_WIDTH, NAVBAR_HEIGHT } from '../constants/constants'
import { Outlet } from 'react-router'

const AppLayout = () => {
  return (
    <Box width='100vw' height='100vh' display='flex' position='relative' overflow='hidden' bgcolor={COLORS.blue200}>
      <Sidebar />
      <Box flex={1}>
        <Navbar />
        <ContentContainer>
          <Outlet />
        </ContentContainer>
      </Box>
    </Box>
  )
}

const ContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(6, 8),
  width: `calc(100vw - ${SIDEBAR_WIDTH})`,
  backgroundColor: COLORS.grey150,
  height: `calc(100vh - ${NAVBAR_HEIGHT})`,
  overflowY: 'scroll'
}))

export default AppLayout
